import React, { Component } from 'react'
import { withRouter } from "react-router-dom";
import PropTypes from 'prop-types';
import { Box, Paragraph, Text, /*TextInput,*/ Button } from 'grommet';
import Header from '../Components/Header';
import Footer from '../Components/Footer';



class RegistrationResult extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.state = {
            otpCode: '',
            disableButton: true
        }
        this.goToLogin = this.goToLogin.bind(this);
        this.goToRegistration = this.goToRegistration.bind(this);
    }

    goToLogin() {
        this.props.history.push({
            pathname: '/login'
        })
    }

    goToRegistration() {

        if (this.props.location.code === 'society') {
            this.props.history.push({
                pathname: '/SocietyRegistration'
            })
        } else {
            this.props.history.push({
                pathname: '/ShopRegistration'
            })
        }
    }

    componentWillMount() {
        if (this.props.location.step !== 4) {
            this.props.history.push({
                pathname: '/login'
            })
        }
    }

    render() {
        const status = this.props.location.state.status

        return (
            <Box>
                <Header />

                <Box direction="column" align='center' className='background-color registration-form'>
                    <Box direction='row' >
                        <h1 className='fixFont' level='1' style={{ marginBottom: '50px' }}>{status === 200 ? 'Registrazione eseguita correttamente!' : 'Si è verificato un errore!'}</h1>
                        <Text className='titlehome' style={{ marginBottom: '5px' }}></Text>
                    </Box>
                    <Box direction='row'>
                        <Paragraph className='textParagraph'>{status === 200 ? 'La registrazione al portale è avvenuta con successo.' : 'La registrazione al portale non è avvenuta. Riprova più tardi'}</Paragraph>
                    </Box>

                    <Box className='informativa' align='center'>
                        {status === 200 ? <Button className='btnform' label='VAI ALLA LOGIN' onClick={this.goToLogin} /> : <Button className='btnform' label='VAI ALLA REGISTRAZIONE' onClick={this.goToRegistration} />}
                    </Box>
                </Box>
                <Footer />
            </Box >
        )
    }
}


export default RegistrationResult = withRouter(RegistrationResult)